import React from 'react'
import './space.css';


class TabSpace extends React.Component {
    render() {
        const { pagename, pathname, extraClass, color, handleClick, label } = this.props;
        const isActive = pathname === '/' + pagename;

        // Hover only bumps weight on tabs that aren't the current page.
        const handleMouseOver = (e) => {
            if (!isActive) e.currentTarget.firstChild.style.fontWeight = '400';
        };
        const handleMouseOut = (e) => {
            if (!isActive) e.currentTarget.firstChild.style.fontWeight = '200';
        };

        const class_name = (extraClass || "w-1/3 h-1/5 ") + pagename + " space";

        return (
            <div className={class_name} data-page={pagename} onClick={handleClick}
                onMouseOver={handleMouseOver} onMouseLeave={handleMouseOut} style={{ backgroundColor: color }}>
                <span
                    className={"page_text" + (isActive ? " underline" : "")}
                    style={{ fontWeight: isActive ? '400' : '200' }}
                >
                    {label || pagename}
                </span>
            </div>
        );
    }
}

export default TabSpace